import { Columns } from '@shared/interfaces/table/column-config';
import { MeterFrameDto } from '@app/api/nts';
import { meterFrameTypePartial } from '@shared/partials/meterframe-type.partial';
import { meterFrameStatusPartial } from '@shared/partials/meterframe-status.partial';
import { meterFrameUnitTypePartial } from '@shared/partials/meterframe-unittype.partial';
import { ClickCellComponent } from '@shared/components/table/cells/click-cell/click-cell.component';
import { DecimalCellComponent } from '@shared/components/table/cells/decimal-cell/decimal-cell.component';

export const meterFrameSerialMasterdata: Columns<MeterFrameDto>[] = [
  meterFrameStatusPartial,
  meterFrameTypePartial,
  {
    title: 'meterFrame.identification',
    key: 'identification'
  },
  {
    title: 'meterFrame.primaryFrame',
    key: 'primaryMeterFrameIdentification',
    cellRenderer: ClickCellComponent,
    cellRendererParams: {
      key: 'primaryMeterFrameId',
      area: 'meterframe'
    }
  },
  meterFrameUnitTypePartial,
  {
    key: 'capacity',
    title: 'meterFrame.capacity',
  },
  {
    key: 'description',
    title: 'meterFrame.description',
  },
  {
    title: 'A14',
    key: 'conversionFactorA14',
    cellRenderer: DecimalCellComponent,
    cellRendererParams: {
      decimals: 4,
      hideIfUndefined: true,
    }
  },
  {
    title: 'A23',
    key: 'conversionFactorA23',
    cellRenderer: DecimalCellComponent,
    cellRendererParams: {
      decimals: 4,
      hideIfUndefined: true,
    }
  },
  {
    title: 'R12',
    key: 'conversionFactorR12',
    cellRenderer: DecimalCellComponent,
    cellRendererParams: {
      decimals: 4,
      hideIfUndefined: true,
    }
  },
  {
    title: 'R34',
    key: 'conversionFactorR34',
    cellRenderer: DecimalCellComponent,
    cellRendererParams: {
      decimals: 4,
      hideIfUndefined: true,
    }
  },
];
